import { render, staticRenderFns } from "./BarChartVolumePerNetwork.vue?vue&type=template&id=6b2ac68c&scoped=true"
import script from "./BarChartVolumePerNetwork.js?vue&type=script&lang=js&external"
export * from "./BarChartVolumePerNetwork.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ac68c",
  null
  
)

export default component.exports